module.exports = __webpack_public_path__ + "img/DSC_2923.938fd154.png";